import axios from "axios";
import setBaseURL from "./baseURL";


export const api = axios.create(
    {
        baseURL: setBaseURL,
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
        },
        withCredentials: false
    }
);

export default api;

